import React from "react"
import GridContainer from "@/components/common/GridContainer"
import HighlightGridCard from "@/components/HighlightGrid/HighlightGridCard"

export default function HighlightGrid({ data = [] }) {
	return (
		<div>
			<GridContainer className="no-margin">
				{data.map((item, index) => (
					<HighlightGridCard data={item} key={item?.id || index} />
				))}
			</GridContainer>
		</div>
	)
}
